import { render, staticRenderFns } from "./CreateNormalInvoicePage.vue?vue&type=template&id=6b82bbca&scoped=true"
import script from "./CreateNormalInvoicePage.vue?vue&type=script&lang=js"
export * from "./CreateNormalInvoicePage.vue?vue&type=script&lang=js"
import style0 from "./CreateNormalInvoicePage.vue?vue&type=style&index=0&id=6b82bbca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b82bbca",
  null
  
)

export default component.exports